import { Controller } from "@hotwired/stimulus"
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import XHRUpload from '@uppy/xhr-upload'
import Webcam from '@uppy/webcam'
import ActiveStorageUpload from '@gothassos/uppy-activestorage-upload'
import it_IT from '@uppy/locales/lib/it_IT.js'

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/status-bar/dist/style.css'
import '@uppy/webcam/dist/style.css'

export default class extends Controller {
  static targets = ["hiddenField"]
  static values = {
    maxFiles: Number,
    height: Number,
    url: String,
    note: String,
    allowedFiles: String,
    autoProceed: Boolean,
    directUpload: Boolean,
    target: String
  }

  connect() {
    let el = this.element

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    this.uppy = new Uppy({
      autoProceed: this.hasAutoProceedValue ? this.autoProceedValue : true,
      restrictions: {
        maxFileSize: 20 * 1024 * 1024,
        maxNumberOfFiles: this.maxFilesValue || 1,
        allowedFileTypes: this.allowedFilesValue ? this.allowedFilesValue.split(',').map(s => s.trim()) : ['image/*', '.pdf'],
      },
      locale: it_IT
    })

    if (this.hasDirectUploadValue && this.directUploadValue) {
      // ✅ Usa direct upload ActiveStorage
      this.uppy.use(ActiveStorageUpload, {
        directUploadUrl: this.urlValue,
      })
    } else {
      // ✅ Usa XHRUpload con endpoint custom
      this.uppy.use(XHRUpload, {
        endpoint: this.urlValue,
        fieldName: 'files[]',
        formData: true,
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        bundle: true
      })
    }

    this.uppy.use(Dashboard, {
      inline: true,
      target: el,
      showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
      height: this.heightValue || 300,
      note: this.noteValue || '',
      showStatusBar: true,
    })

    // this.uppy.use(Webcam, { target: el, modes: ['picture'] });

    this.uppy.on('complete', (result) => {
      if (this.hasDirectUploadValue && this.directUploadValue) {
        // ✅ Direct upload (ActiveStorage)
        const signedIds = result.successful
          .map(file => file.response?.signed_id)
          .filter(Boolean)

        if (this.hasHiddenFieldTarget) {
          this.hiddenFieldTarget.value = signedIds.join(',')
        }
      } else {
        // con bundle: true response è condivisa: sta solo sul primo file
        const response = result.successful.find(f => f.response)?.response
        if (response.body.reload) {
          window.location.reload();
        } else {
          const previewDiv = document.getElementById(this.targetValue)
          if (previewDiv) previewDiv.innerHTML = response.body.html
        }
      }
    })

    if (this.noteValue) {
      const infoEl = el.querySelector('.uppy-Dashboard-AddFiles-info')
      if (infoEl) {
        infoEl.textContent = this.noteValue
        infoEl.style.display = 'block'
      }
    }
  }

  disconnect() {
    if (this.uppy) {
      this.uppy.cancelAll()
      this.uppy.close?.()   // chiamalo solo se esiste (con `?.`)
      this.uppy = null
    }
  }
}
